import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import DOMPurify from "dompurify";

import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import { moment } from "../../../../../utils/LocalizedUtils";
import { getEmailFromId, setCurrentRow, toggleEmailModal } from "../../../../../actions/projectmail";

const mailBuilder = article => {
  let mailPrev = `<div style="background-color: #eee">`;
  for (let i = 0; i < article.length; i += 1) {
    const mail = article[article.length - i - 1];
    mailPrev +=
      '<div style="padding-left: 8px; padding-top: 8px; padding-bottom: 16px; margin-bottom: 16px; background-color: #fff">';
    mailPrev += `<div style="width: 100%; text-align: center">${moment(mail.created_at)
      .tz(moment.tz.guess())
      .format("LLLL")}</div>`;
    mailPrev += `<div style="padding-top: 4px;">From: ${DOMPurify.sanitize(mail.from)}</div>`;
    if (mail.cc !== null) {
      mailPrev += `<div style="padding-top: 4px;">cc: ${DOMPurify.sanitize(mail.cc)}</div>`;
    }
    if (mail.subject !== null) {
      mailPrev += `<div  style="padding-top: 16px; padding-bottom: 16px; font-weight: bold">${DOMPurify.sanitize(
        mail.subject
      )}</div>`;
    }
    mailPrev += `<div style="max-height: 200px; overflow-y: auto; display: block;">${DOMPurify.sanitize(
      mail.body
    )}</div>`;
    if (mail.attachments.length > 0) {
      mailPrev += `<div style="padding-top: 16px; font-weight: bold">Attachments</div>`;
      // eslint-disable-next-line no-loop-func
      mail.attachments.forEach(attachment => {
        mailPrev += `<div><a href="https://zammad.ubivent.net/api/v1/ticket_attachment/${mail.ticket_id}/${mail.id}/${
          attachment.id
        }?disposition=attachment" target="_blank">${DOMPurify.sanitize(attachment.filename)}</a></div>`;
      });
    }
    mailPrev += "</div>";
  }
  mailPrev += "</div>";
  return mailPrev;
};

const EmailModalComponent = ({ rowId, open, closeFn, getEmailFromIdFn, setCurrentRowFn, article }) => {
  const theme = useTheme();
  const [mails, setMails] = useState(undefined);

  useEffect(() => {
    const getEmail = async () => {
      await getEmailFromIdFn(rowId);
    };
    if (article === undefined && rowId !== undefined && open) getEmail();
    if (article !== undefined && rowId !== undefined) {
      setMails(mailBuilder(article));
    }
    return () => {
      setMails(undefined);
    };
  }, [rowId, mails, getEmailFromIdFn, setMails, article, open]);

  return (
    rowId !== undefined && (
      <Modal
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        open={open}
        onClose={() => {
          setCurrentRowFn(undefined);
          closeFn();
        }}
      >
        <Fade in={open}>
          <Box
            sx={{
              width: "80vw",
              maxHeight: "80vh",
              minHeight: "80vh",
              height: "80vh",
              backgroundColor: "#eee",
              border: "2px solid #000",
              boxShadow: theme.shadows[5],
              p: 2,
              justifyContent: "center",
              overflow: "hidden",
            }}
          >
            {mails ? (
              <Box
                sx={{
                  display: "flex",
                  py: 2,
                  my: 2,
                  height: "95%",
                }}
              >
                <Box
                  component="iframe"
                  sx={{
                    flexGrow: 1,
                    border: "none",
                  }}
                  srcDoc={`${mails}`}
                  title="E-Mail"
                  sandbox=""
                  height="auto"
                  width="auto"
                  referrerPolicy="no-referrer"
                />
              </Box>
            ) : (
              <CircularProgress />
            )}
          </Box>
        </Fade>
      </Modal>
    )
  );
};

EmailModalComponent.defaultProps = {
  rowId: undefined,
  article: undefined,
};

EmailModalComponent.propTypes = {
  rowId: PropTypes.number,
  article: PropTypes.array,
  getEmailFromIdFn: PropTypes.func.isRequired,
  setCurrentRowFn: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  closeFn: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  rowId: state.projectmail.currentRow ? state.projectmail.currentRow.id : undefined,
  article: state.projectmail.currentRow ? state.projectmail.articles[state.projectmail.currentRow.id] : undefined,
  open: state.projectmail.emailModalOpen,
});

const mapDispatchToProps = dispatch => ({
  getEmailFromIdFn: async id => {
    await dispatch(getEmailFromId(id));
  },
  setCurrentRowFn: row => dispatch(setCurrentRow(row)),
  closeFn: () => dispatch(toggleEmailModal(false)),
});

const EmailModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(EmailModalComponent);

export default EmailModal;
